import { procurementAPI } from "../../axios";

export const actions = {

    // ItemCategoryGroup
    GetItemCategoryGroup(){
        return procurementAPI.get(`ItemCategoryGroup/All`);
    },
    GetSingleItemCategoryGroup(context, data){
        return procurementAPI.get(`ItemCategoryGroup/${data}`);
    },
    GetItemCategoryGroupAccount(context, data){
        return procurementAPI.get(`ItemCategoryGroup/Account/${data}`);
    },
    UpdateItemCategoryGroup(context, data){
        return procurementAPI.put(`ItemCategoryGroup/Update/${data.id}`, data);
    },
    DeleteItemCategoryGroup(context, data){
        return procurementAPI.delete(`ItemCategoryGroup/Remove/${data}`);
    },
    CreateItemCategoryGroup(context, data){
        return procurementAPI.post(`ItemCategoryGroup/Create`, data);
    },

}